// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-blocks .homepage-block {
  padding: 10px 0 50px 20px;
  border-radius: 5px;
  margin-top: 10px;
  box-shadow: 2px 2px lightgrey;
  font-size: 30px;
  color: #282829;
  background: #dcddde; }
  .homepage-blocks .homepage-block:hover {
    color: #4330ff; }

.homepage-blocks .solar {
  background-color: #fa504b;
  color: white; }

.homepage-blocks img {
  border-radius: 5px;
  margin-top: 10px;
  max-height: 7em;
  display: block;
  margin: auto;
  max-width: 100%; }

.homepage-blocks a:hover {
  text-decoration: none; }

.homepage-blocks .url-link {
  margin-top: 10px; }
  .homepage-blocks .url-link img {
    width: 100%; }

.homepage-blocks .profile-image {
  width: 80px;
  float: right;
  margin-right: 20px; }

.homepage-blocks .fa-stack {
  width: 100%;
  height: 7em;
  overflow: hidden;
  line-height: 1.5; }

.homepage-blocks .fa-stack[data-count]:after {
  position: absolute;
  right: 0%;
  top: 1%;
  content: attr(data-count);
  font-size: .65em;
  padding: .6em;
  border-radius: 999px;
  line-height: .75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold; }

.homepage-blocks .event-name {
  color: #000000; }
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/homepage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB;EACzB,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB,EAAE;EAClB;IACE,WAAW,EAAE;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE","sourcesContent":[".homepage-blocks .homepage-block {\n  padding: 10px 0 50px 20px;\n  border-radius: 5px;\n  margin-top: 10px;\n  box-shadow: 2px 2px lightgrey;\n  font-size: 30px;\n  color: #282829;\n  background: #dcddde; }\n  .homepage-blocks .homepage-block:hover {\n    color: #4330ff; }\n\n.homepage-blocks .solar {\n  background-color: #fa504b;\n  color: white; }\n\n.homepage-blocks img {\n  border-radius: 5px;\n  margin-top: 10px;\n  max-height: 7em;\n  display: block;\n  margin: auto;\n  max-width: 100%; }\n\n.homepage-blocks a:hover {\n  text-decoration: none; }\n\n.homepage-blocks .url-link {\n  margin-top: 10px; }\n  .homepage-blocks .url-link img {\n    width: 100%; }\n\n.homepage-blocks .profile-image {\n  width: 80px;\n  float: right;\n  margin-right: 20px; }\n\n.homepage-blocks .fa-stack {\n  width: 100%;\n  height: 7em;\n  overflow: hidden;\n  line-height: 1.5; }\n\n.homepage-blocks .fa-stack[data-count]:after {\n  position: absolute;\n  right: 0%;\n  top: 1%;\n  content: attr(data-count);\n  font-size: .65em;\n  padding: .6em;\n  border-radius: 999px;\n  line-height: .75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold; }\n\n.homepage-blocks .event-name {\n  color: #000000; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
